// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth} from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDrZZEClq5v7DCXCzA-mYYYyCkdsNIRDDY",
  authDomain: "ok-market-46b67.firebaseapp.com",
  projectId: "ok-market-46b67",
  storageBucket: "ok-market-46b67.firebasestorage.app",
  messagingSenderId: "173489216143",
  appId: "1:173489216143:web:4f445047f2dd3f4b352efa",
  measurementId: "G-4BD1XF1GGS"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
console.log("Firebase project:", auth.app.options.projectId);

export { app, analytics, auth };





